export default [
  {
    path: "/vendas",
    component: () => import("@/layouts/SalesLayout.vue"),
    children: [
      {
        path: "visao-geral",
        name: "sales",
        component: () => import("../views/sales/SalesIndex.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          protected: true,
          permissions: ["acessar-vendas"],
          viewContainer: true,
          breadcrumbs: ["sales"],
          title: "Visão geral de vendas",
          description: "Visualização e exportação do relatório de suas vendas."
        }
      },
      {
        path: "/vendas/eventos",
        name: "sales-events",
        component: () => import("../views/sales/EventSales.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          breadcrumbs: ["sales-events"],
          protected: true,
          permissions: ["acessar-vendas"],
          viewContainer: true,
          title: "Eventos",
          description:
            "Visualização e exportação do relatório de vendas dos seus eventos."
        }
      },
      {
        path: "/vendas/assinaturas",
        name: "sales-subscriptions",
        component: () => import("../views/sales/SubscriptionSales.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          protected: true,
          permissions: ["acessar-vendas"],
          viewContainer: true,
          breadcrumbs: ["sales", "sales-subscriptions"],
          title: "Assinaturas",
          description:
            "Visualização e exportação do relatório de vendas das suas assinaturas."
        }
      },
      {
        path: "/vendas/curso-online",
        name: "sales-courses",
        component: () => import("../views/sales/CourseSales.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          protected: true,
          permissions: ["acessar-vendas"],
          viewContainer: true,
          breadcrumbs: ["sales", "sales-courses"],
          title: "Cursos",
          description:
            "Visualização e exportação do relatório das vendas de seus cursos."
        }
      },
      {
        path: "/vendas/recuperacao",
        name: "sales-recovery",
        component: () => import("../views/sales/SaleRecovery.vue"),
        meta: {
          template: () => import("../templates/Default.vue"),
          protected: true,
          permissions: ["acessar-vendas"],
          viewContainer: true,
          breadcrumbs: ["sales-recovery"],
          title: "Recuperação de vendas",
          description:
            "Recupere informações dos clientes que abandonaram a sua página de checkout"
        }
      }
    ]
  },
  {
    path: "/vendas-presenciais",
    name: "card-machine",
    component: () => import("../views/sales/CardMachine.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["acessar-vendas"],
      viewContainer: true,
      breadcrumbs: ["sales"],
      title: "Vendas presenciais",
      description: "Gerencie vendas na máquina de cartão"
    }
  }
];
